<script>
import Editor from '@/components/Editor1/Editor.vue'
import { reactive, onMounted, toRefs, computed, watch, getCurrentInstance, ref } from '@vue/composition-api'
import { renderFun } from './business/renderForm'
import { form, rules } from './business/constant'
import initList from './composables/initList'
import token from '@/composables/token'
import storage from 'store'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import compuedFun from './computed/'
import { casesTemplateFields, casesCreate, casesUpdate, casesDetail } from '@/api/caseManagement/index'
import VDatePicker from '@/components/FormElements/VDatePicker'
import yzImageUpload from '@/components/yzImageUpload'
import yzVideoUpload from '@/components/yzVideoUpload'

const title = {
  Add: '添加案例',
  Edit: '编辑案例'
}

const tipMapping = {
  input: '请输入，最多不超过1000字',
  // "textarea": "多行文本支持换行",
  // "editor": "富文本支持设置字体样式、段落、排版布局，支持上传图片、附件等",
  // "radio": "",
  // "checkbox": "",
  "number": "请输入，最多2位小数",
  datePicker: '请选择，日期格式如 2022-01-01',
  upload: '单张图片支持jpg、jpeg、png、gif，单张图不超过5M'
}

export default {
  components: {
    Editor,
    VDatePicker,
    yzImageUpload,
    yzVideoUpload
  },
  setup(props, { root }) {
    const _this = getCurrentInstance()
    const isEdit = computed(() => !!_this.$route.params.id)
    const articleID = computed(() => _this.$route.params.id)

    const state = reactive({
      form: { ...form },
      rules,
      expandForm: {}, // 案例内容->拓展字段表单
      expandRules: {}, // 案例内容->拓展字段规则
      baseURL: process.env.VUE_APP_API_BASE_URL,
      title: title.Add,
      submitLoading: false,
      smetaList: [],
      renderFormList: [],
      token: storage.get(ACCESS_TOKEN)
    })

    const tagVisible = ref(null)
    onMounted(async () => {
      await methods.getTemplateFields()
      const id = articleID.value
      if (id) {
        state.title = title.Edit
        getDetail()
      } else {
        state.form.line_id = Number(_this.line_id)
      }
    })

    function changePlatform(e) { }

    async function getDetail() {
      state.submitLoading = true
      const res = await casesDetail({ id: articleID.value })
      if (_this.$validate(res)) {
        const { fields, ...resData } = res.data
        const formKeys = Object.keys(state.form)
        for (const key of formKeys) {
          if (resData[key]) {
            state.form[key] = resData[key]
          }
        }
        state.form.line_id = Number(state.form.line_id)
        const expandFormKeys = Object.keys(state.expandForm)
        for (const key of expandFormKeys) {
          state.expandForm[key] = fields.find(item => String(item.field_id) === String(key))?.value ?? undefined
        }
        state.submitLoading = false
        // state.renderFormList
      }
    }
    async function commitAction(postParams) {
      try {
        _this.submitLoading = true
        const res = articleID.value ? await casesUpdate(postParams) : await casesCreate(postParams)
        if (_this.$validate(res)) {
          _this.$message.success(articleID.value ? '编辑成功!' : '添加成功!')
          _this.back()
        } else {
          _this.submitLoading = false
        }
      } catch (error) {
        _this.submitLoading = false
      }
    }

    function handleSubmit() {
      methods
        .validForm()
        .then(async res => {
          try {
            // _this.submitLoading = true
            const postParams = { ...state.form }
            postParams.template_fields = { ...state.expandForm }
            postParams.template_id = _this.template_id
            if (articleID.value) {
              _this.$confirm({
                okText: '确定',
                cancelText: '取消',
                content: '编辑保存后需重新进行审核，确认保存？',
                onOk() {
                  commitAction(postParams)
                },
              })
            } else {
              commitAction(postParams)
            }
          } catch (error) {
            _this.submitLoading = false
          }
        })
        .catch(() => {
          this.$message.warning('请检查信息是否填写完成')
        })
    }

    const methods = {
      validForm() {
        return Promise.all([_this.$refs.refForm.validate(), _this.$refs.refExpandForm.validate()])
      },
      back() {
        this.$router.push('/casesManage')
      },
      async getTemplateFields() {
        const res = await casesTemplateFields({
          case_id: articleID.value,
          template_id: _this.template_id
        })
        if (_this.$validate(res)) {
          const _renderFormList = (res.data.template_fields || [])
          _renderFormList.forEach(item => { item.field_id = '' + item.field_id })
          _renderFormList.forEach(o => {
            if (['checkbox', 'radio'].includes(o.field_type)) {
              o.options = methods.getFormItemOptions(o.field_value)
            }
            // _this.$set(state.expandForm, o.field, undefined)
            _this.$set(state.expandForm, o.field_id, undefined)
            // 多选、上传 默认数组
            if (['checkbox', 'upload'].includes(o.field_type)) {
              // _this.$set(state.expandForm, o.field, [])
              _this.$set(state.expandForm, o.field_id, [])
            }
            methods.createdRules(o)
          })
          state.renderFormList = _renderFormList
        }
      },
      getFormItemOptions(fieldValue) {
        let _options = []
        if (!fieldValue || !Array.isArray(fieldValue)) return _options
        _options = fieldValue.map(({ value }) => {
          return {
            label: value,
            value: value
          }
        })
        return _options
      },
      createdRules(data) {
        ; +data.must === 1 &&
          _this.$set(_this.expandRules, data.field_id, [
            { required: true, message: methods.showTips(data), trigger: ['change', 'blur'] }
          ])
      },
      showTips(data) {
        // if (data.field_tip) { // 自定义提示内容
        //   return data.field_tip
        // } else
        if (['checkbox', 'radio', 'datePicker'].includes(data.field_type)) {
          return tipMapping[data.field_type] ? tipMapping[data.field_type] : `请选择`
        } else if (['input', 'textarea', 'editor', 'number'].includes(data.field_type)) {
          return tipMapping[data.field_type] ? tipMapping[data.field_type] : `请输入`
        } else if (['upload'].includes(data.field_type)) {
          return tipMapping[data.field_type] ? tipMapping[data.field_type] : '请上传图片'
        } else if (['videoUpload'].includes(data.field_type)) {
          return tipMapping[data.field_type] ? tipMapping[data.field_type] : '请上传视频'
        }
      },
      filterOption(input, option) {
        return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
    }

    return {
      ...toRefs(state),
      ...compuedFun(),
      ...initList(),
      ...token(),
      isEdit,
      articleID,
      tagVisible,
      changePlatform,
      getDetail,
      handleSubmit,
      ...methods
    }
  },
  render() {
    return (
      <a-card title={this.title}>
        <a-form-model
          ref="refForm"
          attrs={{ rules: this.rules, model: this.form }}
          label-col={{ span: 5 }}
          wrapper-col={{ span: 14 }}
          labelAlign={'right'}
        >
          <a-divider orientation="left">发布平台</a-divider>
          <a-row>
            <a-col xs={24} sm={24} md={24} lg={12} xl={12}>
              <a-form-model-item label="发布平台：" prop="line_id">
                <a-select
                  vModel={this.form.line_id}
                  allowClear
                  show-search
                  placeholder="请选择发布平台"
                  onChange={this.changePlatform}
                  filter-option={this.filterOption}
                >
                  {this.selfPlatformList.map(item => (
                    <a-select-option key={item.id} value={item.id}>
                      {item.org}
                    </a-select-option>
                  ))}
                </a-select>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col xs={24} sm={24} md={24} lg={12} xl={12}>
              <a-form-model-item label="案例标题：" prop="title">
                <a-input vModel={this.form.title} placeholder="请输入标题，不超过100字" maxLength={100} />
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-form-model>

        <a-form-model
          ref="refExpandForm"
          attrs={{ rules: this.expandRules, model: this.expandForm }}
          label-col={{ span: 5 }}
          wrapper-col={{ span: 14 }}
          labelAlign={'right'}
        >
          <a-divider orientation="left">案例内容</a-divider>
          {this.renderFormList.map((o, idx) => {
            if (renderFun[o.field_type]) {
              return <a-row key={o.field_id}>{renderFun[o.field_type].call(this, o)}</a-row>
            }
          })}
          <a-row>
            <a-col span="24">
              <a-form-model-item wrapper-col={{ span: 20, offset: 2 }}>
                <a-button class="mr20" loading={this.submitLoading} type="primary" onClick={this.handleSubmit}>
                  保 存
                </a-button>
                <a-button onClick={this.back}>取 消</a-button>
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-form-model>
      </a-card>
    )
  }
}
</script>

<style lang="less" scoped>
.tailor-img {
  width: 100px;
  height: 100px;
  cursor: pointer;
}

.img-default {
  width: 100px;
  height: 100px;
  background-color: #f5f7fa;
  display: flex;
  justify-content: center;
  align-items: center;
}

.pc-preview {
  background-color: orange;
  position: fixed;
  width: 100%;
  height: 100%;
}

.tags-swapper {
  max-height: 200px;
  min-height: 40px;
  overflow-y: auto;
  border: 2px solid #eee;
  padding: 3px 5px;
  border-radius: 5px;

  /deep/.ant-tag {
    margin-right: 5px !important;
    border: 1px solid #d9d9d9;
  }
}
</style>

<style lang="less">
.pc-container {
  width: 100%;
  height: 700px;
  overflow-y: auto;

  /deep/img {
    width: 100%;
    height: auto;
  }
}

.wap-container {
  width: 375px;
  height: 667px;
  overflow-y: auto;
}

.preViewWap {
  /deep/img {
    width: 100%;
    height: auto;
  }
}
</style>
